export default function Node_Buffer() {
  return <div>Node_Buffer Component</div>;
}
